module.exports = "<div class=ui-grid-cell-contents> <div ng-class=\"(row.entity.subject_status_name == 'Activo') ? 'text-verde' : ''\"> <p>{{row.entity.subject_status_name}}</p> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/app/u-faculty/generalSettings/subjects/list/listSubjectStateCell.html
// module id = 286
// module chunks = 0